// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2vn-o","label":"Completed_label__3D-NE"};